// source: PrivateDealsV3Api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.PrivateDealsV3Api', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PrivateDealsV3Api = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PrivateDealsV3Api, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PrivateDealsV3Api.displayName = 'proto.PrivateDealsV3Api';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PrivateDealsV3Api.prototype.toObject = function(opt_includeInstance) {
  return proto.PrivateDealsV3Api.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PrivateDealsV3Api} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PrivateDealsV3Api.toObject = function(includeInstance, msg) {
  var f, obj = {
price: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, ""),
amount: jspb.Message.getFieldWithDefault(msg, 3, ""),
tradetype: jspb.Message.getFieldWithDefault(msg, 4, 0),
ismaker: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
isselftrade: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
tradeid: jspb.Message.getFieldWithDefault(msg, 7, ""),
clientorderid: jspb.Message.getFieldWithDefault(msg, 8, ""),
orderid: jspb.Message.getFieldWithDefault(msg, 9, ""),
feeamount: jspb.Message.getFieldWithDefault(msg, 10, ""),
feecurrency: jspb.Message.getFieldWithDefault(msg, 11, ""),
time: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PrivateDealsV3Api}
 */
proto.PrivateDealsV3Api.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PrivateDealsV3Api;
  return proto.PrivateDealsV3Api.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PrivateDealsV3Api} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PrivateDealsV3Api}
 */
proto.PrivateDealsV3Api.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPrice(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTradetype(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsmaker(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsselftrade(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTradeid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientorderid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOrderid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFeeamount(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFeecurrency(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PrivateDealsV3Api.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PrivateDealsV3Api.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PrivateDealsV3Api} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PrivateDealsV3Api.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTradetype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIsmaker();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getIsselftrade();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getTradeid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getClientorderid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFeeamount();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFeecurrency();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTime();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
};


/**
 * optional string price = 1;
 * @return {string}
 */
proto.PrivateDealsV3Api.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string quantity = 2;
 * @return {string}
 */
proto.PrivateDealsV3Api.prototype.getQuantity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string amount = 3;
 * @return {string}
 */
proto.PrivateDealsV3Api.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setAmount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 tradeType = 4;
 * @return {number}
 */
proto.PrivateDealsV3Api.prototype.getTradetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setTradetype = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool isMaker = 5;
 * @return {boolean}
 */
proto.PrivateDealsV3Api.prototype.getIsmaker = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setIsmaker = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool isSelfTrade = 6;
 * @return {boolean}
 */
proto.PrivateDealsV3Api.prototype.getIsselftrade = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setIsselftrade = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string tradeId = 7;
 * @return {string}
 */
proto.PrivateDealsV3Api.prototype.getTradeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setTradeid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string clientOrderId = 8;
 * @return {string}
 */
proto.PrivateDealsV3Api.prototype.getClientorderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setClientorderid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string orderId = 9;
 * @return {string}
 */
proto.PrivateDealsV3Api.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string feeAmount = 10;
 * @return {string}
 */
proto.PrivateDealsV3Api.prototype.getFeeamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setFeeamount = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string feeCurrency = 11;
 * @return {string}
 */
proto.PrivateDealsV3Api.prototype.getFeecurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setFeecurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 time = 12;
 * @return {number}
 */
proto.PrivateDealsV3Api.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.PrivateDealsV3Api} returns this
 */
proto.PrivateDealsV3Api.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


goog.object.extend(exports, proto);
